module.exports = __webpack_public_path__ + "img/logo-menu-branco.e848bcbe.png";